import { Turbo } from '@hotwired/turbo-rails';
import { modalContainer } from '@/js/modules/turbo-modal';
import '@/js/modules/jquery_modal_defaults';

/**
 * Custom action that logs a message to the browser console.
 * @this StreamElement
 * */
Turbo.StreamActions.console_log = function () {
  console.log(this.target);
};

/**
 * Custom action that scrolls given container to top.
 * @this StreamElement
 * */
Turbo.StreamActions.scroll_to_top = function () {
  const id = this.target;
  const element = document.getElementById(id);

  if (!element) {
    throw new Error(`turbo_stream.scroll_to_top: Element with id=${id} cannot be found on a page`);
  }

  element.scrollTop = 0;
};

/**
 * Custom action that opens modal.
 * @this StreamElement
 * */
Turbo.StreamActions.open_modal = function () {
  const id = this.target;
  let showClose = true;
  let modal;

  if (id) {
    modal = $(`#${id}`);
  } else {
    modal = $(this.templateContent.firstElementChild);
    // don't remove immediately, give some time for events to bubble up
    modal.one($.modal.AFTER_CLOSE, ({ target }) => setTimeout(target.remove.bind(target), 1000));
    const dataShowClose = this.getAttribute('data-show-close');
    if (dataShowClose) {
      showClose = dataShowClose === 'true';
    }
  }

  modal.is(':visible') || modal.modal({ showClose });

  const focusElement = modal.find('[data-js-focus-on-open]')[0];
  focusElement?.focus();

  const length = focusElement?.value?.length;
  length && focusElement.setSelectionRange(length, length);
};

/**
 * Custom action that closes modal
 * */
Turbo.StreamActions.close_modal = function () {
  $.modal.close();
};

/**
 * Custom action that opens a turbo modal (jQuery-free).
 * Appends the template content to the modal container. The ui--turbo-modal
 * Stimulus controller handles the rest (animation, events, stacking).
 * @this StreamElement
 * */
Turbo.StreamActions.open_dialog = function () {
  const content = this.templateContent.firstElementChild.cloneNode(true);
  modalContainer().appendChild(content);
};

/**
 * Custom action that closes the dialog around the target frame, or the current one when the target is "current".
 * @this StreamElement
 * */
Turbo.StreamActions.close_dialog = function () {
  if (this.target !== 'current') {
    const frame = document.getElementById(this.target);
    const twin = frame?.closest('dialog[data-controller~="ui--twin-turbo-modal"]');
    const modal = frame?.closest('[data-controller~="ui--turbo-modal"]');

    if (twin) {
      twin.close();
    } else if (modal) {
      modal.dispatchEvent(new CustomEvent('turbo-modal:request-close', { bubbles: false }));
    }

    return;
  }

  const modals = document.querySelectorAll('[data-controller~="ui--turbo-modal"]');
  const last = modals[modals.length - 1];
  if (last) {
    last.dispatchEvent(new CustomEvent('turbo-modal:request-close', { bubbles: false }));
  }

  const twins = document.querySelectorAll('dialog[data-controller~="ui--twin-turbo-modal"][open]');
  twins[twins.length - 1]?.close();
};

/**
 * Custom action that performs a Turbo visit (client-side redirect).
 * Usage: turbo_stream.action(:redirect, url)
 * @this StreamElement
 * */
Turbo.StreamActions.redirect = function () {
  Turbo.visit(this.target);
};

/**
 * Custom action that performs a genuine full page reload to a URL (sets
 * window.location, no Turbo snapshot visit). Use this when the destination
 * relies on legacy full-page-reload JS that re-initializes on load — e.g.
 * forms rendered inside a Turbo Frame (the share modal), whose redirects
 * Turbo would otherwise follow as in-place visits.
 * Usage: turbo_stream.action(:hard_redirect, url)
 * @this StreamElement
 * */
Turbo.StreamActions.hard_redirect = function () {
  window.location.href = this.target;
};

/**
 * Custom action that reloads the current page, keeping its URL and query string.
 * Use this when the user should stay where they are and the page relies on legacy
 * full-page-reload JS to pick up the change — e.g. recording a purchase order
 * payment from the order tracker, whose origin the billable redirect params
 * cannot express. The target is unused; the destination is always "here".
 * Usage: turbo_stream.action(:hard_reload, "")
 * @this StreamElement
 * */
Turbo.StreamActions.hard_reload = function () {
  window.location.reload();
};

/**
 * Custom action to trigger a cancel event on a given target
 * @this StreamElement
 * */
Turbo.StreamActions.cancel = function () {
  const target = $(this.target)[0];
  const event = new CustomEvent('cancel');

  target?.dispatchEvent(event);
};

Turbo.StreamActions.insert_billable_items = function () {
  const position = this.getAttribute('position');
  const target = this.targetElements[0];

  if (!target) {
    return;
  }

  const container = ['before', 'after'].includes(position) ? target.parentElement : target;
  const lastRowBeforeInsert =
    position === 'after'
      ? target
      : ([...container.querySelectorAll(':scope > .billable-item')].at(-1) ?? null);

  Turbo.StreamActions[position].call(this);

  target.dispatchEvent(
    new CustomEvent('billable-items:inserted', {
      bubbles: true,
      detail: { container, lastRowBeforeInsert },
    })
  );
};
